module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_2_01_thumb.878d4b32.png";